module.exports = __webpack_public_path__ + "img/status-rank.fa7d2343.png";